export var removeElement=function(e){var o;e.remove?e.remove():null===(o=e.parentNode)||void 0===o||o.removeChild(e)};